import {SmartComponent} from "smart-component-js";
import GenericModalComponent from "../utils/GenericModalComponent";

class PartecipaIniziativaModalComponent extends SmartComponent {

    constructor(element, parentComponent, params) {
        super(element, parentComponent, params);
        this.element = element;
        this.modal = new GenericModalComponent(this.element);
        this.exit = this.element.querySelectorAll('.exit a');
        this.missionsRaw = this.element.dataset.externalMission || '';
        this.missionName = this.element.querySelector('.mission-name')

        this.init();
    }


    checkMission() {

        this.missions = this.missionsRaw
            .replace(/\[|\]/g, '')
            .split(',')
            .map(m => m.trim())
            .filter(Boolean);

        this.currentIndex = 0;
        this.showMission();
    }

    showMission() {
        if (this.currentIndex >= this.missions.length) return;
        this.missionName.textContent = this.missions[this.currentIndex];
        this.modal.openModal();

    }


    addModalListener() {
        this.exit.forEach((el) => {
            el.addEventListener('click', () => {
                this.modal.closeModal();

                setTimeout(() => {
                    this.currentIndex++;
                    this.showMission();
                }, 300);
            });
        })

    }


    init() {
        this.checkMission();
        this.addModalListener();
    }
}

export default PartecipaIniziativaModalComponent;
